import { TraceConfig } from '@dashboard/models';

export default {
  options: [
    {
      id: 1,
      label: 'BF',
      metricLabel: 'Wind speed',
      metricUnit: 'BF',
      description: "Color vessels's trail based on wind speed",
      icon: 'wind.svg',
      traceTag: 'COORD',
      templateTag: 'WIND_SPEED_ABS_BF',
      traceId: '10004',
      templateId: '10035',
      range: [
        {
          min: 0,
          max: 4,
          color: '#1B8A5A',
          label: '0',
          maxInclusive: false,
        },
        {
          min: 4,
          max: 5,
          color: '#1D4877',
          label: '4',
          maxInclusive: false,
        },
        {
          min: 5,
          max: 6,
          color: '#FBB021',
          label: '5',
          maxInclusive: false,
        },
        {
          min: 6,
          max: 100,
          color: '#EE3E32',
          label: '6+',
          maxInclusive: false,
        },
      ],
    },
    {
      id: 2,
      label: 'kn',
      metricLabel: 'Speed',
      metricUnit: 'kn',
      description: "Color vessels's trail based on speed (absolute range)",
      icon: 'speedometer.svg',
      traceTag: 'COORD',
      templateTag: 'SOG',
      traceId: '10004',
      templateId: '10027',
      range: [
        {
          min: 0,
          max: 4,
          color: '#1D4877',
          label: '0-4',
        },
        {
          min: 4,
          max: 8,
          color: '#1B8A5A',
          label: '4-8',
        },
        {
          min: 8,
          max: 12,
          color: '#FBB021',
          label: '8-12',
        },
        {
          min: 12,
          max: 16,
          color: '#F68838',
          label: '12-16',
        },
        {
          min: 16,
          max: 100,
          color: '#EE3E32',
          label: '16+',
        },
      ],
    },
    {
      id: 3,
      label: 'kn',
      metricLabel: 'Speed',
      metricUnit: 'kn',
      description: "Color vessels's trail based on speed (relative range)",
      traceId: '10004',
      traceTag: 'COORD',
      templateTag: 'SOG',
      icon: 'speed-deviations.svg',
      templateId: '10027',
      range: [],
      relativeValues: {
        minIncrementRange: 1,
        colorRanges: ['#1D4877', '#1B8A5A', '#FBB021', '#F68838', '#EE3E32'],
      },
    },
    {
      id: 4,
      label: 'CPA',
      metricLabel: 'CPA',
      description: "Color vessels's trail based on contractual compliance.",
      traceId: '10004',
      traceTag: 'COORD',
      templateTag: 'CPA_COMPLIANCE',
      icon: 'cpa.svg',
      templateId: '10071',
      colorFade: false,
      range: [
        {
          min: 0,
          max: 0,
          color: '#7d7a7a',
          tooltip: 'Not Avaliable',
          label: 'NA',
        },
        {
          min: 1,
          max: 1,
          color: '#1D4877',
          tooltip: 'Exclusion',
          label: 'E',
        },
        {
          min: 2,
          max: 2,
          color: '#EE3E32',
          label: 'U',
          tooltip: 'Underperforming',
        },
        {
          min: 3,
          max: 3,
          color: '#FBB021',
          label: 'O',
          tooltip: 'Overperforming',
        },
        {
          min: 4,
          max: 4,
          color: '#1B8A5A',
          label: 'C',
          tooltip: 'Compliant',
        },
      ],
    },
  ],
} as {
  options: TraceConfig[];
};
